const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        fsRemainingLabel: cc.Label,
        headerBg: cc.Node,
    },

    updateFSRemaining (freerounds) {
        this.headerBg.active = true;
        this.fsRemainingLabel.node.active = true;

        let message;
        let win;

        switch (freerounds.type) {
            case 'NUM_ROUNDS':
                message = i18n.t('free-spins') + ' ' + freerounds.data.numLeft;
                break;
            case 'SPIN_WIN':
                win = i18n.formatCurrency(freerounds.config.targetWin);
                message = i18n.t('header-message-free-round-single-win-pending', { '0': win });
                break;
            case 'TOTAL_WIN':
                win = i18n.formatCurrency(freerounds.config.targetWin);
                message = i18n.t('header-message-free-round-total-win-pending', { '0': win });
                break;
            case 'UNSPECIFIED':
                this.headerBg.active = false;
                this.fsRemainingLabel.node.active = false;
                return;
        }
        this.fsRemainingLabel.string = message;
        this.headerBg.width = (message.length * 11 + 15) / this.headerBg.scaleX;
    },

    isActive () {
        return this.node.active;
    },

    show () {
        this.node.active = true;
    },

    hide () {
        this.node.active = false;
    }
});
